// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".canvas-cursor[data-v-21543702]{pointer-events:none;border:2px solid #000;opacity:.3}.thick[data-v-21543702]{opacity:.8;border-width:4px}.focus[data-v-21543702]{fill:#ffc107;opacity:.3;width:30px;transform:translate(-14px)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
